import { DomainService } from "./DomainService";

const baseUrl = DomainService.GetBaseUrl() + "airaa/";
const apiKey = import.meta.env.VITE_API_KEY;


const GetAiraaMember=async(bouser,pageindex,pagesize,filter)=>{
    try {
        const res = await fetch(baseUrl + "getallmembers?bousers=" + bouser + "&pageindex=" + pageindex+"&pagesize=" + pagesize+"&filter=" + filter, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': apiKey
            },
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.log(error);
    }
}
const GetBoUserDetailsByRaid=async(raid)=>{
    try {
        const res = await fetch(baseUrl + "get-bouserdetails-byuserid?raId=" + raid , {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': apiKey
            },
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.log(error);
    }
}
const ActivateFreeMembership=async(formData)=>{
        try {
        const res = await fetch(baseUrl + "activate-free-membership", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': apiKey
            },
            body: JSON.stringify(formData)
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.log(error);
    }
}  


export const MemberService = {
    GetAiraaMember,
    GetBoUserDetailsByRaid,
    ActivateFreeMembership
}